import { render, staticRenderFns } from "./GroupTemplateList.vue?vue&type=template&id=670201fc&scoped=true&"
import script from "./GroupTemplateList.vue?vue&type=script&lang=js&"
export * from "./GroupTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./GroupTemplateList.vue?vue&type=style&index=0&id=670201fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670201fc",
  null
  
)

export default component.exports